module.exports = __webpack_public_path__ + "img/english-flag.a1c61be6.svg";